export default {"src":"/_next/static/media/card_24.42bc00df.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};